import React from 'react';
import { Chip, useT } from '@repo/common';

import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/16px/icon_16px_plus_outline.svg';
import { ReactComponent as CancelIcon } from '@repo/common/assets/icons/16px/icon_16px_cancel.svg';
import { ReactComponent as HeaderCancelIcon } from '@repo/common/assets/icons/20px/icon_20px_cancel.svg';

const PopularSkills = ({ onSelect, selected, onClose, $isMobile }) => {
  const t = useT();
  const populars = [
    'Project Management',
    'Data Analysis',
    'Communication Skills',
    'Microsoft Excel',
    'HTML',
    'Problem Solving',
    'Cross-functional Collaboration',
    'Google Workspace',
    'SQL',
    'Research Skills',
    'Adobe PhotoShop',
  ];

  const mobilePopulars = [
    'Communication Skills',
    'Microsoft Excel',
    'HTML',
    'Problem Solving',
    'Cross-functional Collaboration',
  ];
  const list = $isMobile ? mobilePopulars : populars;

  return (
    <div className='flex flex-col items-start w-full tabletH:p-6 tabletH:pt-4 bg-grayscale-gray00 tabletH:bg-grayscale-gray01 rounded-[8px]'>
      <div className='flex justify-between items-center w-full pb-3 tabletH:pb-4'>
        <div className='typo-b14Strong tabletH:typo-b16Strong text-text-primary'>
          {t('Popular skills', '인기 스킬')}
        </div>
        {!$isMobile && (
          <button
            type='button'
            onClick={onClose}
            className='text-icon-primary hover:text-icon-primary/60'
          >
            <HeaderCancelIcon />
          </button>
        )}
      </div>

      <div className='flex flex-wrap gap-3'>
        {list.map((skill) => {
          const isSelected = selected.includes(skill);

          return (
            <Chip
              key={skill}
              onClick={() => onSelect(skill)}
              state={isSelected ? 'selected' : 'default'}
              bgclass='tabletH:bg-grayscale-gray01'
              icon={isSelected ? <CancelIcon /> : <PlusIcon />}
              iconPosition='after'
            >
              {skill}
            </Chip>
          );
        })}
      </div>
    </div>
  );
};

export default PopularSkills;
